module.exports = __webpack_public_path__ + "img/in-the-spotlight.79c739e2.png";